<template>
  <div id="payMessage">
    <div class="sector bg-darker df fc">
	  <div class="fs30">Вы были перенаправлены на <a :href="data.url" target="_blank">сайт оплаты</a>.</div>
      <div class="sub">Пожалуйста нажмите кнопку “я оплатил” после оплаты</div>
      <div class="fs24">Номер заказа: {{ data.id }}</div>
    </div>

    <button class="fs24" @click="paid(false)">Я оплатил</button>
  </div>
</template>

<script>
import { GetOrderStatusRequest } from "@/protos/user_pb.js";

export default {
  props: ["data"],

  data() {
	return { i: null }
  },

  mounted() {
	window.open(this.data.url, "_blank")

	this.i = setInterval(() => this.paid(true), 5000)
  },

  methods: {
	paid(auto = false) {
	  const r = new GetOrderStatusRequest()
	  r.setId(this.data.id)
	  this.$root.client.getOrderStatus(r, null, (err, resp) => {
		if (err)
		  return this.$root.toast.error(err)

		if (resp.getStatus() !== "registered") {
		  clearInterval(this.i)
		  return this.$root.setState({
			label: "success",
			data: this.data
		  })
		} else if(!auto)
		  this.$root.toast.info("Пока еще не пришло")
	  })
	}
  }
}
</script>
